import { MenuType } from "@src/@types/MenuITypes";
import { ReactComponent as GlobeIcon } from "../../assets/images/pages/globe.svg";
import { ReactComponent as NotebookIcon } from "../../assets/images/pages/Notebook.svg";
import { ReactComponent as DashboardIcon } from "../../assets/images/pages/layout-dashboard.svg";


const Menu : MenuType[]= [
  // {
  //   id: "home",
  //   title: "Home",
  //   icon: <Home size={20} />,
  //   navLink: "/home",
  // },
  {
    id: "dashboard",
    title: "dashboard",
    icon: <DashboardIcon width={24} height={24} />,
    navLink: "/dashboard",
  },
  {
    id: "sites",
    title: "sites",
    icon: <GlobeIcon width={24} height={24} />,
    navLink: "/sites",
  },
  {
    id: "script",
    title: "installation",
    icon: <NotebookIcon width={24} height={24} />,
    navLink: "/installation",
  }
];
export default Menu
